import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  const isAdmin = user?.role === 'admin';
  const navLinks = isAdmin
    ? [
        { to: '/admin', label: 'Dashboard' },
        { to: '/admin/staff', label: 'Staff' },
        { to: '/admin/attendance', label: 'Attendance' },
        { to: '/admin/settings', label: 'Settings' },
      ]
    : [
        { to: '/dashboard', label: 'Dashboard' },
        { to: '/attendance', label: 'Take Attendance' },
        { to: '/history', label: 'My History' },
      ];

  return (
    <nav style={styles.nav}>
      <div style={styles.inner}>
        <Link to={isAdmin ? '/admin' : '/dashboard'} style={styles.brand}>
          <span style={styles.brandIcon}>📋</span>
          <span style={styles.brandText}>AttendTrack</span>
        </Link>

        {/* Desktop links */}
        <div style={styles.links}>
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              style={{
                ...styles.link,
                ...(location.pathname === link.to ? styles.linkActive : {}),
              }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* User info & logout */}
        <div style={styles.userArea}>
          <span style={styles.userName}>{user?.full_name?.split(' ')[0]}</span>
          <button onClick={handleLogout} style={styles.logoutBtn}>Logout</button>
        </div>

        {/* Mobile hamburger */}
        <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={styles.mobileMenu}>
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              style={styles.mobileLink}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <button onClick={handleLogout} style={styles.mobileLogout}>Logout</button>
        </div>
      )}
    </nav>
  );
}

const styles = {
  nav: { background: '#fff', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 100 },
  inner: { maxWidth: 1200, margin: '0 auto', padding: '0 1rem', height: 60, display: 'flex', alignItems: 'center', gap: '1.5rem' },
  brand: { display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' },
  brandIcon: { fontSize: '1.5rem' },
  brandText: { fontWeight: 700, fontSize: '1.1rem', color: '#2563eb' },
  links: { display: 'flex', gap: '0.25rem', flex: 1, '@media(max-width:768px)': { display: 'none' } },
  link: { padding: '0.5rem 0.75rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, color: '#64748b', textDecoration: 'none', transition: 'all 0.15s' },
  linkActive: { background: '#dbeafe', color: '#2563eb' },
  userArea: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
  userName: { fontSize: '0.875rem', fontWeight: 500, color: '#374151' },
  logoutBtn: { padding: '0.4rem 0.875rem', background: '#f1f5f9', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: '0.8rem', fontWeight: 500, color: '#475569' },
  hamburger: { display: 'none', background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'pointer', padding: '0.25rem', marginLeft: 'auto' },
  mobileMenu: { background: '#fff', borderTop: '1px solid #e2e8f0', padding: '0.75rem 1rem', display: 'flex', flexDirection: 'column', gap: '0.25rem' },
  mobileLink: { padding: '0.625rem 0.75rem', borderRadius: 8, fontSize: '0.875rem', color: '#374151', textDecoration: 'none', display: 'block' },
  mobileLogout: { padding: '0.625rem 0.75rem', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: '0.875rem', color: '#dc2626', borderRadius: 8 },
};
